import { VStack, NextLink, customEvent, ClickEventType, Spacing, HLine, colors } from "goi_common";

import dayjs from "dayjs";
import { Box } from "@chakra-ui/react";

interface Review {
  id: number;
  headline: string;
  score: number;
  created_at: string;
  user: {
    nickname: string;
  };
  isCurrent?: boolean;
  event: ClickEventType;
  good: string;
  bgColor: string;
  color: string;
  contentColor: string;
  editColor: string;
  serviceName: string;
}

export function HomeRenewalReviewCard({
  id,
  created_at,
  good,
  user,
  event,
  color,
  contentColor,
}: Review) {
  return (
    <VStack justifyContent="space-between" gap={0}>
      <NextLink
        href={`/review/${id}/`}
        onClick={() => {
          customEvent({ newGtm: event });
        }}
      >
        <VStack gap={0} padding="0 24px 24px">
          <Spacing gap={8} />
          <Box className="body_14_r gray900">{good.slice(0, 130)}...</Box>
          <Spacing gap={12} />
          <div className="caption_12_r gray600">
            {user.nickname}님 | {dayjs(created_at).format("YYYY년 M월 D일")}
          </div>
        </VStack>

        <HLine height="1px" color={colors.gray100} />
        <Box className="body_14_r gray700" padding="16px 0" textAlign="center">
          자세히보기
        </Box>
      </NextLink>
    </VStack>
  );
}
